import type { IconProps } from './types';
import './icons.css';

export default function SandWatch({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-sand-watch ${className || ''}`}
    >
      <g clipPath="url(#a-sand-watch)">
        <path
          d="M12 4a4 4 0 1 1-8 0V.57h8V4Z"
          stroke="currentColor"
          strokeWidth="1.714"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path d="M4 6h8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" fill="currentColor" />
        <path
          d="M12 12a4 4 0 1 0-8 0v3.429h8V12ZM1.714.571h12.572M1.714 15.429h12.572"
          stroke="currentColor"
          strokeWidth="1.714"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="transparent"
        />
        <path fill="currentColor" d="M4 12h8v3.333H4z" />
      </g>
      <defs>
        <clipPath id="a-sand-watch">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
